import { Controller } from "@hotwired/stimulus"

// CSP's style-src blocks style="" attributes and <style> tags (and once any
// page uses a style nonce, 'unsafe-inline' is ignored for the whole
// directive, so an un-nonced style= anywhere else on that page breaks too).
// It does NOT restrict setting individual CSS properties via the CSSOM
// (element.style.setProperty) — that's the standard, spec-sanctioned way to
// apply per-element, request-computed styles (a progress-bar width, a
// data-driven marker color) that can never be a static Tailwind class
// because the value only exists at render time.
//
// Also covers the onmouseover/onmouseout="this.style.x='y'" pattern for a
// dynamic hover color: inline event-handler attributes are themselves a
// script-src concern (and the exact inline-script surface CSP nonces exist
// to close), not just style-src, so replacing them here removes both at once.
//
// Usage:
//   <div data-controller="inline-style"
//        data-inline-style-css-value='{"width": "42%", "background-color": "#00558A"}'
//        data-inline-style-hover-css-value='{"background-color": "#145230"}'>
export default class extends Controller {
  static values = { css: Object, hoverCss: Object }

  connect() {
    this.apply(this.cssValue)
    if (Object.keys(this.hoverCssValue).length) {
      this.element.addEventListener("mouseenter", () => this.apply(this.hoverCssValue))
      this.element.addEventListener("mouseleave", () => this.apply(this.cssValue))
    }
  }

  apply(css) {
    for (const [prop, val] of Object.entries(css)) {
      if (val !== null && val !== undefined && val !== "") {
        this.element.style.setProperty(prop, val)
      }
    }
  }
}
